import React from 'react';
import '../../App.css';
function Spinner() {
  return (
    <div className="spinner">
      <div className="spinner-circle"></div>
      <div className="spinner-circle"></div>
      <div className="spinner-circle"></div>
      <div className="spinner-shadow"></div>
      <div className="spinner-shadow"></div>
      <div className="spinner-shadow"></div>
    </div>
  );
}

export default Spinner;
